import { render } from "./UpdatePasswordContainer.vue?vue&type=template&id=69325f5c"
import script from "./UpdatePasswordContainer.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__